import { render, staticRenderFns } from "./PieForResultChart.vue?vue&type=template&id=44083952&scoped=true&"
import script from "./PieForResultChart.vue?vue&type=script&lang=js&"
export * from "./PieForResultChart.vue?vue&type=script&lang=js&"
import style0 from "./PieForResultChart.vue?vue&type=style&index=0&id=44083952&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44083952",
  null
  
)

export default component.exports